var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIButtonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.61342 6.47537C1.52262 6.33161 1.47723 6.25973 1.45182 6.14886C1.43273 6.06559 1.43273 5.93425 1.45182 5.85097C1.47723 5.74011 1.52262 5.66823 1.61341 5.52447C2.36369 4.33648 4.59693 1.33325 8.00027 1.33325C11.4036 1.33325 13.6369 4.33648 14.3871 5.52447C14.4779 5.66823 14.5233 5.74011 14.5487 5.85097C14.5678 5.93425 14.5678 6.06559 14.5487 6.14886C14.5233 6.25973 14.4779 6.33161 14.3871 6.47537C13.6369 7.66336 11.4036 10.6666 8.00027 10.6666C4.59693 10.6666 2.36369 7.66336 1.61342 6.47537Z",
    stroke: "#98A2B3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00027 7.99992C9.10484 7.99992 10.0003 7.10449 10.0003 5.99992C10.0003 4.89535 9.10484 3.99992 8.00027 3.99992C6.8957 3.99992 6.00027 4.89535 6.00027 5.99992C6.00027 7.10449 6.8957 7.99992 8.00027 7.99992Z",
    stroke: "#98A2B3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIButtonIcon);
export default __webpack_public_path__ + "static/media/iButton-icon.67c9e52fbcf81525f72251cc16619b56.svg";
export { ForwardRef as ReactComponent };